module.exports = __webpack_public_path__ + "img/Differentiation-ASHN_GSE227469.169eb18b.png";